import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CustomerService {

	private _customerProfile: BehaviorSubject<any>
	private _customerPolicies: BehaviorSubject<any>
	private _customerQuotes: BehaviorSubject<any>
	private _customerId: any

  	constructor(private apiService: ApiService) {

		  this._customerProfile = new BehaviorSubject({})
		  this._customerPolicies = new BehaviorSubject({})
		  this._customerQuotes = new BehaviorSubject({})
		  

  	}

  	get profile(){
  		return this._customerProfile
  	}

  	set profile(data){
  		this._customerProfile.next(data)
  	}

	get policies(){
		return this._customerPolicies
	}

	get quotes(){
		return this._customerQuotes
	}

	set policies(data){
		this._customerPolicies.next(data)
	}

	set quotes(data){
		this._customerQuotes.next(data)
	}

  	retrieveCustomer(id){

  		return new Promise((resolve, reject) => {
  			this.apiService.request('GET', '/customer/:customerId', {customerId: id})
	  		.then((response)=>{
	  			this._customerProfile.next(response)
	  			resolve()
	  		})
	  		.catch(error=>{
	  			console.log(error)
	  			reject(error.message)
	  		})

  		})
  		
	  }
	  
	  retrieveCustomerPolicies(id){

		return new Promise((resolve, reject) => {
			this.apiService.request('GET', '/customer/:customerId/policies', {customerId: id})
			.then((response)=>{
				this._customerPolicies.next(response)
				resolve()
			})
			.catch(error=>{
				console.log(error)
				reject(error.message)
			})

		})
		
	}


	retrieveCustomerQuotes(id){

		return new Promise((resolve, reject) => {
			this.apiService.request('GET', '/customer/:customerId/quotes', {customerId: id})
			.then((response)=>{
				this._customerQuotes.next(response)
				resolve()
			})
			.catch(error=>{
				console.log(error)
				reject(error.message)
			})

		})
		
	}

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/customer-service/customer.service.ts